// extracted by mini-css-extract-plugin
module.exports = {"download":"index_download_2D9Bi"};